if (!customElements.get('details-modal')) {
  class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.closeButton = this.querySelector('button[type="button"]');

      if (!this.detailsContainer || !this.summaryToggle) return;

      this.detailsContainer.addEventListener('keyup', (event) => {
        if ((event.code || '').toUpperCase() === 'ESCAPE') this.close();
      });
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.closeButton?.addEventListener('click', this.close.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
      return Boolean(this.detailsContainer?.hasAttribute('open'));
    }

    onSummaryClick(event) {
      event.preventDefault();
      this.isOpen() ? this.close() : this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!this.contains(target) || target.classList.contains('modal-overlay')) this.close(false);
    }

    open() {
      if (!this.detailsContainer || !this.summaryToggle) return;
      this.onBodyClickEvent ||= this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', '');
      document.body?.addEventListener('click', this.onBodyClickEvent);
      document.body?.classList.add('overflow-hidden');

      const focusRoot = this.detailsContainer.querySelector('[tabindex="-1"]');
      const firstInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
      if (focusRoot && typeof trapFocus === 'function') trapFocus(focusRoot, firstInput || focusRoot);
    }

    close(focusToggle = true) {
      if (!this.detailsContainer) return;
      if (typeof removeTrapFocus === 'function') removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body?.removeEventListener('click', this.onBodyClickEvent);
      document.body?.classList.remove('overflow-hidden');
    }
  }

  customElements.define('details-modal', DetailsModal);
}
